import React, { useState, useEffect, useMemo } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, formatdate, getdate,updatedata, sendwhatsappmessage, WAITINGGIF} from "../../util/global";


const WebhookForm = ({ showmodal, setshowmodal, formdata, setformdata, phonenumberdata }) => {
    
  useEffect(() => { 
  }, [showmodal]);

  if (showmodal != "showwebhookform" ) return null;

  const updatewebhookmessage = async () => {
    $("#waitinggif").show();
    let payload =[{_id:formdata._id,"phonenumber":formdata.phonenumber, datatype:"phonenumberdata", webhookmessage: formdata.webhookmessage}];
    console.log(payload);
    let postres = await updatedata({dataset:payload}, "/updatephonenumber");
  
    let phonenumber = phonenumberdata.find(item => item._id == formdata._id);
    phonenumber.webhookmessage = formdata.webhookmessage;
    setshowmodal("");
  };



  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>Webhook URL https://ssl.itpatil.com/webhook?_phonenumberid={formdata._id}</h3>
          <button className="close-btn" onClick={() => setshowmodal(false)}>&times;</button>
        </div>
        <div className="modal-body">
          

           <div className="form-group">
            <label>Webhook Message</label>
            <textarea 
              type="text" 
              className="form-input" 
              value={formdata.webhookmessage} 
              onChange={(e: { target: { value: any; }; }) => setformdata({...formdata, webhookmessage: e.target.value})} 
            />              
          </div>
        
          <button className="btn-blue full-width " onClick={() => {updatewebhookmessage();}}>
            {formdata._id ? "Save" : "Save"} <img id="waitinggif" src="/css/whatsappapi/waiting.gif" style={{display:'none', width:'25px',position:'absolute'}}/>
          </button>
        </div>
      </div>
    </div>
  );
};

export default WebhookForm;
